import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { MaskedLine, FadeUp, Overline } from "@/components/Reveal";
import { EnquiryForm } from "@/components/LeadForm";

export default function Contact() {
  const [params] = useSearchParams();
  const program = params.get("program") || "";

  return (
    <main data-testid="contact-page" className="pt-32 sm:pt-44 pb-32 sm:pb-44">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          <div className="lg:col-span-5">
            <Overline className="mb-10">Contact</Overline>
            <h1 className="font-serif text-5xl sm:text-7xl font-light tracking-tighter leading-[0.95] text-ink">
              <MaskedLine delay={0.2}>Let's make</MaskedLine>
              <MaskedLine delay={0.35} className="italic text-sage">
                it quieter.
              </MaskedLine>
            </h1>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="mt-12 flex flex-col gap-8"
            >
              <p className="text-base sm:text-lg leading-relaxed text-neutral-600 max-w-md">
                Tell me where the chaos lives. I read every message myself and reply
                within two working days — no assistants, no funnels, no pressure.
              </p>
              <div className="flex flex-col gap-2">
                <p className="text-xs uppercase tracking-[0.25em] text-neutral-500">Prefer email?</p>
                <a
                  href="mailto:hello@klaconsulting.co"
                  data-testid="contact-email-link"
                  className="font-serif text-2xl text-ink hover:text-sage transition-colors duration-300 w-fit"
                >
                  hello@klaconsulting.co
                </a>
              </div>
            </motion.div>
          </div>

          <FadeUp delay={0.3} className="lg:col-span-6 lg:col-start-7">
            <div className="bg-bone border border-border p-8 sm:p-14">
              <EnquiryForm defaultInterest={program} />
            </div>
          </FadeUp>
        </div>
      </div>
    </main>
  );
}
